import { useQuery } from "@tanstack/react-query";
import * as QueryKeys from "data";
import { fetchClipProducts } from "data/queries-common";
import { CatalogueProduct, mapClipProduct } from "./catalogue";

// Loads the Clip product catalogue from GET /clip/products and maps it into the
// camelCase CatalogueProduct shape the UI works in. The catalogue is global and
// effectively static, so it's cached aggressively.
export const useClipProducts = () =>
  useQuery<CatalogueProduct[]>({
    queryKey: [QueryKeys.clipProductsKey],
    queryFn: async () => {
      const raw = await fetchClipProducts();
      return raw.map(mapClipProduct);
    },
    staleTime: 1000 * 60 * 60, // 1 hour — catalogue rarely changes
    // The app's QueryClient uses the default 5-minute gcTime, which would evict
    // the catalogue whenever the last observer unmounts (closing a clip) and
    // refetch on the next open, never reaching the staleTime above. Keep it for
    // the session instead — it's ~9KB and shared by the picker and the summary.
    gcTime: Infinity,
  });
